import React from 'react';
import { isAppOld } from '../../lib/ep.js';
import { useOwner } from '../context/context.js';

import RibbonCollection from '../ui_items/RibbonCollection.js';
import Tooltip from '../builder/Tooltip.js';

const OldPromoTag = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	if(!isAppOld(promotion.promotion_type_id)) return null;

	return (
		<RibbonCollection
			_class={{ other:'gui_not_in_top_tiny' }}
			items={[{
				title:"Old Promotion",
				color:'red',
				_href:`${window.zendesk_base_url}20264497867284`,
				_target:'_blank',
				tooltip:<Tooltip with_icon={false} position='top'>Click to find out what the Old Promotion tag means</Tooltip>
			}]}
		/>
	)
}

export default OldPromoTag;